import React, { useEffect } from "react";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { findGetParameter } from "../../components/utilities/UtilityFunctions";
import {
  useProcessing,
  useSignout
} from "../../components/user/BCPAuthReducers";
import { signout } from "../../components/user/BCPAuth";
import { stringToUrl } from "../events/utils/event";
import { postNotification } from "../../components/utilities/Notifications";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { getLocalStorage } from "../../components/layout/cookies/CookieFunctions";

const SUPPORTS_BCP_PLATFORM_FEATURES =
  getEnvironmentVariable("SUPPORTS_BCP_PLATFORM_FEATURES") === "true";

export default function LogOut() {
  const useSignoutReducer = useSignout();
  const useProcessingReducer = useProcessing();

  // Generic Sign Out used for gold labels
  async function GenericSignOut() {
    await signout(useSignoutReducer, {
      setProcessing: useProcessingReducer
    });
  }

  // Sign Out used for BCP
  async function BCPLogout() {
    try {
      const findUrlRedirect = findGetParameter("redirect_uri")
        ? findGetParameter("redirect_uri")
        : getLocalStorage("bcpRedirectUrl")
          ? getLocalStorage("bcpRedirectUrl")
          : document?.referrer && document?.referrer !== ""
            ? document.referrer
            : window.location.origin;

      const redirectUrl = `${getEnvironmentVariable(
        "AUTH_HOSTED_UI"
      )}logout?client_id=${getEnvironmentVariable(
        "AUTH_CLIENT_ID"
      )}&redirect_uri=${stringToUrl(`${findUrlRedirect}`)}`;

      await signout(useSignoutReducer, {
        redirectUrl: redirectUrl
      });
    } catch (err) {
      postNotification("error", err);
      window.location.assign("/");
    }
  }

  useEffect(() => {
    if (SUPPORTS_BCP_PLATFORM_FEATURES) {
      BCPLogout();
    } else {
      GenericSignOut();
    }
    // eslint-disable-next-line
  }, []);

  return <ModalLoadingFull />;
}
